import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import {
    CarrierServiceResponse,
    CarrierServiceResponseSchema,
} from '../../../../pb/responses/v1/carrier_service_response_pb';

/**
 * Both endpoints act on the ecom of the current session, so neither takes an ecom id, and neither has
 * a request body — hence the `null` request schema.
 */
const createService = async (): Promise<CarrierServiceResponse> =>
    new ProtobufClient(goBackendApi()).postRequest(
        null,
        CarrierServiceResponseSchema,
        '/api/v1/carrier-service/create'
    );

const deleteService = async (): Promise<CarrierServiceResponse> =>
    new ProtobufClient(goBackendApi()).postRequest(
        null,
        CarrierServiceResponseSchema,
        '/api/v1/carrier-service/delete'
    );

export default {
    createService,
    deleteService,
};
